<template>
  <div class="avatar-container">
    <figure v-if="!isIE" class="avatar is-flex"><img :src="src" alt=""></figure>
    <div v-if="isIE" class="ie-avatar" :style="{ 'background-image': 'url(' + src + ')'}"> </div>
  </div>
</template>

<script>
import userAgent from '@/libs/user-agent'
import imageProxy from '@/libs/image-proxy'

export default {
  props: ['user'],

  computed: {
    isIE: function () {
      return userAgent.isIE11()
    },
    src: function () {
      return imageProxy.thumbnail(this.user.avatar)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

.avatar-container {
  height: 24px;
  height: 24px;
}

.avatar {
  align-items: center;
  height: 1.5rem;
  width: 1.5rem;
  min-height: 24px;
  min-width: 24px;
  margin-right: 0.2rem;
  display: block;
  @include mobile {
    height: 1.4rem;
    width: 1.4rem;
  }
  img {
    height: inherit;
    width: inherit;
    display: block;
    background: white;
    border-radius: 50%;
    box-shadow: 1px 1px 0.5px rgba(0,0,0,0.1);
  }
}
.ie-avatar {
  background-position: center;
  background-size: cover;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  box-shadow: 1px 1px 0.5px rgba(0,0,0,0.1);
  display: block;
  margin-right: .4rem;
  @include mobile {
    height: 1.2rem;
    width: 1.2rem;
  }
}

</style>
